/*
Isotope Scripts
*/

(function($){  
	jQuery('body').imagesLoaded(function(){ 

		function initFilterAtts( element ){
			if (!$(element).attr('data-filter') && $(element).parents('.theme_block_menu').length > 0 && $(element).attr('href').indexOf('category/') > 0) {
				var indexOfCategorySlug = $(element).attr('href').indexOf('category/') + 'category/'.length;
				var categorySlug = $(element).attr('href').slice(indexOfCategorySlug, -1);
				$(element).attr('data-filter','.'+categorySlug);
			}
		}

		var $mosaic;
		var $button = $('.filters .filter-button, .theme_block_menu a');
		var $select = $('.filters select');
		console.log($button);

		if ($('.category').length > 0 || $('.page-template-template-all-articles').length > 0) {
			// For categories and all-articles
			$mosaic = $('.mosaic');

			// Init grid
			$mosaic.isotope({
				itemSelector: '.grid-item',
				

				// Init sorting criteria
				getSortData: {
					type: '[data-type]',
					date: '[data-date]'
				},
				sortBy: 'date',
				sortAscending: false

			});

			// Set up data-filter atts for menu items
			if ($('.page-template-template-all-articles').length > 0) {
				$button.each(function(){
					initFilterAtts( this );
				});
			}
			
		} else if ($('.events-list').length > 0) {
			// Disable base Javascript for Events form which seems to fuck everything up 
			$('#tribe-bar-form').off();

			$mosaic = $('.isotope-list');  
			// Init grid
			$mosaic.isotope({
				itemSelector: '.isotope-list-item',
				layoutMode: 'vertical',
			});
			$button.each(function(){
				initFilterAtts( this );
			});
			
		}
		
		var filters = {};
		function setFilters( element ) {
			filterGroup = $(element).parents('.filter-group').attr('data-filter-group');
			var filterValue;
			if ($(element).attr('data-filter')) {
				filterValue = $(element).attr('data-filter');
			} else if ($(element).find(':selected').length > 0) {
				filterValue = $(element).find(':selected').val();
			}
			filters[ filterGroup ] = filterValue;
			combinedFilterValue = concatValues( filters );
			console.log(combinedFilterValue);
			$mosaic.isotope({
				filter: combinedFilterValue
			});
			applyActiveClasses(element);
			if (filters.cat && filters.cat != '*') {
				// If theme is set, copy html to the active filter box
				var themeHTML = $('.theme_block_menu [data-filter="'+filters.cat+'"]').html();
				$('.active-theme').html(themeHTML);
				// Then close box
				jQuery('.theme_accordion').foundation('up', jQuery('.theme_accordion .accordion-content').first() );
			} else {
				$('.active-theme').empty();
			}

			displayHideNoContentBox();
		}

		function resetThemes(){
			filters.cat = '*';
			combinedFilterValue = concatValues( filters );
			console.log(combinedFilterValue);
			$mosaic.isotope({
				filter: combinedFilterValue
			});

			applyActiveClasses( 0 );
			$('.active-theme').empty();
			$('theme_block_menu').removeClass('.faded');
		}
		function setSort( element ){
			var sortAscending = true;
			if ($(element).attr('data-order') && $(element).attr('data-order') === 'DESC') {
				sortAscending = false;
			}
			$mosaic.isotope({
				sortBy: $(element).attr('data-sort'),
				sortAscending: sortAscending
			});
			applyActiveClasses(element);
		}

		function applyActiveClasses( element ){
			if (element !== 0) {
				// If a filter button was pressed
				$(element).parents('.row').find('.filter-button').not($(element)).removeClass('active');
				$(element).parents('.theme_block_menu').find('a').not($(element)).removeClass('active');
				console.log(filters.cat);
				if (filters.cat && filters.cat != '*') {
					// If category isn't 'all'
					$('.reset-filters a').addClass('enabled');
				} else {
					$('.reset-filters a').removeClass('enabled');
				}
				$(element).addClass('active');
			} else {
				// If 'reset themes' button was pressed
				$('.theme_block_menu').find('a').removeClass('active');
				$('.theme_block_menu').removeClass('faded');
				$('.reset-filters a').removeClass('enabled');
			}
		}

		// flatten object by concatting values
		function concatValues( obj ) {
		  var value = '';
		  for ( var prop in obj ) {
		    value += obj[ prop ];
		  }
		  return value;
		}

		// Display or hide the no-content box
		function displayHideNoContentBox() {
			var $messageBox = jQuery('#isotope-no-results');

			if ($mosaic.data('isotope').filteredItems.length === 0) {
				$messageBox.fadeIn();
			} else {
				$messageBox.fadeOut();
			}
		}



		$button.click(function(){
			
			if ($(this).attr('data-filter')) {
				setFilters(this);
			} 
			if ($(this).attr('data-sort')) {
				setSort(this);
			}
			// add faded class to theme_block_menu if has active button within
			$('.theme_block_menu').each(function(){
				if ($(this).find('.active').length > 0) {
					$(this).addClass('faded');
				} else {
					$(this).removeClass('faded');
				}
			});
			return false;
		});

		$select.change(function(){
			setFilters(this);
		});

		$('.reset-filters').click(function(){
			resetThemes();
		});


		// Set filter to 'Articles' on article page 
		$('.page-template-template-all-articles .filter-button[data-filter=".iso-article"]').click();
		


	});

})( jQuery );
